import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { Transformation } from 'app/model/dataflow/transformation';
import { containNonASCII, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { AzureBlobFSLinkedService, LinkedService } from 'shell-models-lib';
import { AzureBlobStorageLinkedService } from 'app/model/linkedservice/azure-blob-storage.linkedservice';
import { AmazonS3LinkedService } from 'app/model/linkedservice/amazon-s3.linkedservice';
import { GoogleCloudStorageLinkedService } from 'app/model/linkedservice/google-cloud-storage.linkedservice';

export class DataFlowUtils {
    public static dataFlowEscapeValidation: RegExp = /\,|\`|\.|\~|\!|\@|\$|\%|\^|\&|\*|\(|\)|\+|\-|\=|\[|\{|\]|\}|\||\\|\'|\<|\>|\?|\/|\"|\;|\:|\s|^[0-9]|^\_|\#/;

    public static escapeFieldIfNeeded(field: string): string {
        return this.needToEscape(field) ? `{${field}}` : field;
    }

    public static needToEscape(name: string): boolean {
        if (!name) {
            return true;
        } else if (name.startsWith('{') && name.endsWith('}')) {
            return false;
        }
        return DataFlowUtils.dataFlowEscapeValidation.test(name) || containNonASCII(name);
    }

    public static topologicalSort(transform: Transformation, stack: Transformation[], visited: Map<Transformation, boolean>): void {
        if (visited.get(transform)) {
            return;
        }
        visited.set(transform, true);

        transform.getDownTransformations().forEach((outputTransform) => {
            DataFlowUtils.topologicalSort(outputTransform, stack, visited);
        });
        stack.push(transform);
    }

    public static sinkCompare(aSink: DataFlowSink, bSink: DataFlowSink): number {
        if ((aSink.saveOrder.templateExpression && bSink.saveOrder.templateExpression) ||
            (stringIsNullOrEmpty(aSink.saveOrder.expression) && stringIsNullOrEmpty(bSink.saveOrder.expression))) {
            return 0;
        } else if (stringIsNullOrEmpty(aSink.saveOrder.expression)) {
            return 1;
        } else if (stringIsNullOrEmpty(bSink.saveOrder.expression)) {
            return -1;
        } else if (aSink.saveOrder.templateExpression) {
            return 1;
        } else if (bSink.saveOrder.templateExpression) {
            return -1;
        } else {
            return +aSink.saveOrder.expression - +bSink.saveOrder.expression;
        }
    }

    public static hasContainer(linkedService: LinkedService): boolean {
        return linkedService instanceof AzureBlobStorageLinkedService
            || linkedService instanceof AzureBlobFSLinkedService
            || linkedService instanceof AmazonS3LinkedService
            || linkedService instanceof GoogleCloudStorageLinkedService;
    }
}
